import type { Icon } from '@phosphor-icons/react';
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface EmptyStateProps {
  icon?: Icon;
  /** Ilustração opcional (ver components/illustrations). Quando presente, substitui o ícone. */
  illustration?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
  /** Sem borda tracejada (quando já está dentro de um painel). */
  bare?: boolean;
}

export function EmptyState({ icon: IconCmp, illustration, title, description, action, className, bare }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 px-6 py-14 text-center',
        !bare && 'rounded-panel border border-dashed bg-card/50',
        className,
      )}
    >
      {illustration ? (
        <div className="mb-1">{illustration}</div>
      ) : (
        IconCmp && (
          <span className="flex size-12 items-center justify-center rounded-panel bg-sand text-sand-foreground">
            <IconCmp className="size-6" weight="duotone" aria-hidden />
          </span>
        )
      )}
      <div className="max-w-sm">
        <h3 className="font-display text-base font-semibold">{title}</h3>
        {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
      </div>
      {action}
    </div>
  );
}
